module.exports = __webpack_public_path__ + "img/customer04.92e3bc2.png";